import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const me = async () => {
    return getUser("me");
}

export const getUser = async (id) => {
    const url = `/api/v1/users/${id}`;
    const res = await axios.get(url);
    return res.data;
}

export const getUsers = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/users?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const patchMe = async (data) => {
    return patchUser("me", data);
}

export const patchUser = async (userId, data) => {
    const url = `/api/v1/users/${userId}`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const createUser = async (data) => {
    const url = `/api/v1/users`;
    const res = await axios.post(url, data);
    return res.data;
}

export const createApiKey = async () => {
    const url = `/api/v1/users/me/api_key`;
    const res = await axios.post(url);
    return res.data;
}

export const confirmEmail = async (userId) => {
    const url = `/api/v1/users/${userId}/email_confirmation`;
    const res = await axios.post(url);
    return res.data;
}

export const deleteUser = async (userId) => {
    const url = `/api/v1/users/${userId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const exportUsers = async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/users/export?${urlParams.toString()}`;
    const res = await axios.get(url, {responseType: 'blob'});
    const disposition = res.headers["content-disposition"];
    const fileName = disposition.split("filename=")[1];
    return {data: res.data, fileName};
}